import React, { SVGProps } from 'react';
const addFilled = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M25.333 17.333h-8v8h-2.667v-8h-8v-2.667h8v-8h2.667v8h8z" /></svg>;
export default addFilled;